import AppHelper from 'js/app/AppHelper';

const featureSupport = {
    attachmentSourceSize: {
		SK: '8.18',
        SE: '8.1',
        EASe: '5.18'
    },
    attachmentRESTV2: {
        SK: '8.19',
        SE: '7.10',
        EASe: '5.19'
    }
}

const isFeatureEnable = featureName => {
    let enabled = false;

    const sourceType = AppHelper.getAppData('enterpriseType')
    const sourceVersion = AppHelper.getParamData('currentbuildversion').split(".");
    const supportedVersion = featureSupport[featureName][sourceType].split('.');

    sourceVersion[0] = parseInt(sourceVersion[0].replace(/%20/g, '').match(/\d/g).join(''));
    sourceVersion[1] = parseInt(sourceVersion[1]);
    supportedVersion[0] = parseInt(supportedVersion[0]);
    supportedVersion[1] = parseInt(supportedVersion[1]);

    if ( sourceVersion[0] > supportedVersion[0] || 
        ( sourceVersion[0] === supportedVersion[0] && sourceVersion[1] >= supportedVersion[1] )) {
            enabled = true;
    }

    return enabled;
}

export default isFeatureEnable;